import React, { useState } from 'react'
import { number, bool } from 'prop-types'
import classnames from 'classnames'

import storage from 'utils/storage'
import csrfToken from 'utils/csrfToken'
import API, { axios } from 'utils/API'

import Loader from 'components/utils/Loader'
import Typography from 'components/atoms/Typography'
import Button from 'components/atoms/Button'

const StickyContent = ({ num, enabled }) => {
  const [isLoading, setIsLoading] = useState(false)
  const redirectToResult = () => {
    if (enabled) {
      const selectedIds = storage.get('common', 'selectedIds')
      const saveIds = selectedIds.map(id => axios({
        url: API.endPoints().toggleInterest,
        method: 'post',
        responseType: 'json',
        data: {
          school_id: id,
        },
        headers: {
          'X-CSRF-Token': csrfToken(),
        },

      }))

      setIsLoading(true)
      Promise.all(saveIds)
        .then(() => {
          window.location.href = `/aptitude_test/report/${storage.get('serverProps', 'reportId')}`
        })
        .catch(() => {
          setIsLoading(false)
        })
    }
  }

  return (
    <div className="aptitude-recommendation__sticky-content">
      <Typography component="p" variant="body" className="aptitude-recommedation__sticky-text">
        {num} Kampus Terpilih
      </Typography>
      <Button
        className={
          classnames('aptitude-recommendation__redirect-btn', {
            disabled: !enabled,
          })
        }
        component="button"
        type="button"
        onClick={redirectToResult}
        disabled={!enabled}
      >
        <div className="aptitude-recommendation__btn-content">
          { isLoading && <Loader className="aptitude-recommendation__btn-loader" kind="doubleCircle" />}
          { !isLoading && 'Lihat Hasil' }
        </div>
      </Button>
      <style jsx>
        {`
          .aptitude-recommendation__sticky-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            :global(.aptitude-recommedation__sticky-text) {
              font-weight: bold;
            }
            &__btn-content {
              svg {
                animation-name: rubberBand;
                animation-duration: 1s;
                animation-fill-mode: both;

                #body {
                  fill: #fb627a;
                  stroke: #fb627a;
                }
              }
            }
            :global(.aptitude-recommendation__btn-loader) {
              width: 20px;
              display: block;
              margin: 0 4px;
              filter: drop-shadow(-2px -1px 4px #fff);
            }
            :global(.aptitude-recommendation__redirect-btn) {
              font-size: 14px;
              font-weight: bold;
              box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.85);
              padding: 14px 28px;
              border: none;
              width: fit-content;
              @media screen and (min-width: 768px) {
                width: unset;
              }
            }
            :global(.aptitude-recommendation__redirect-btn.disabled) {
              background-color: #bed2e8;
              cursor: not-allowed;
            }
          }
        `}
      </style>
    </div>
  )
}

StickyContent.propTypes = {
  num: number,
  enabled: bool,
}

export default StickyContent
